module.exports = __webpack_public_path__ + "static/media/downmobarrow.29a07ed8.svg";